import { PackageManagement } from "@/components/PackageManagement";

export default function PackagesPage() {
  return <PackageManagement />;
}


